import styled from '@emotion/styled';
import emotionFirstChildSelector from '@/lib/styling/emotionFirstChildSelector';

const Separator = styled('hr')(({ theme }) => ({
  marginBottom: 22.5,
  border: 'none',
  borderTop: `2px dashed ${theme.palette.divider}`,
  [emotionFirstChildSelector]: {
    display: 'none',
  },
}));

export default Separator;
